/**
 * 用户 Store
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { UserInfo, UserListResponse, UserQueryParams } from '../types/user';
import { getUserPage, createUser, updateUser, deleteUser } from '../services/api/user';

interface UserState {
  // 状态
  userList: UserInfo[];
  currentUser: UserInfo | null;
  total: number;
  loading: boolean;

  // Actions
  fetchUserList: (params?: UserQueryParams) => Promise<void>;
  createUser: (params: any) => Promise<void>;
  updateUser: (id: number, params: any) => Promise<void>;
  deleteUser: (id: number) => Promise<void>;
  setCurrentUser: (user: UserInfo | null) => void;
  clearUserList: () => void;
}

export const useUserStore = create<UserState>()(
  devtools((set, get) => ({
    userList: [],
    currentUser: null,
    total: 0,
    loading: false,

    fetchUserList: async (params = {}) => {
      set({ loading: true });
      try {
        // 调用真实 API
        const response = await getUserPage(params);
        set({ userList: response.records, total: response.total, loading: false });
      } catch (error) {
        console.error('获取用户列表失败:', error);
        set({ loading: false });
        throw error;
      }
    },

    createUser: async (params) => {
      try {
        await createUser(params);
        await get().fetchUserList();
      } catch (error) {
        console.error('创建用户失败:', error);
        throw error;
      }
    },

    updateUser: async (id, params) => {
      try {
        await updateUser(id, params);
        await get().fetchUserList();
      } catch (error) {
        console.error('更新用户失败:', error);
        throw error;
      }
    },

    deleteUser: async (id) => {
      try {
        await deleteUser(id);
        await get().fetchUserList();
      } catch (error) {
        console.error('删除用户失败:', error);
        throw error;
      }
    },

    setCurrentUser: (user) => {
      set({ currentUser: user });
    },

    clearUserList: () => {
      set({ userList: [], total: 0 });
    },
  }))
);
